
// This would be in a file like src/utils/mock/candidates.ts
import type { Candidate } from "@/components/candidates/types";

export const mockCandidates: Candidate[] = [
  {
    id: "cand-001",
    first_name: "Alex",
    last_name: "Johnson",
    email: "alex.johnson@example.com",
    phone: "+1 (555) 123-4567",
    source: "LinkedIn",
    status: "new",
    linkedin_url: "https://linkedin.com/in/alex-johnson",
    experience_years: 5,
    notes: "Full-stack developer with React and Node.js experience.",
    created_at: "2023-05-15T10:00:00Z",
    updated_at: "2023-05-15T10:00:00Z",
    last_contact: "2023-05-15T10:00:00Z",
    resume_url: null,
    skills: ["React", "TypeScript", "Node.js", "GraphQL", "AWS"],
    current_role: "Senior Developer at TechCorp",
    assigned_posting: {
      company: "TechCorp",
      title: "Senior Frontend Developer"
    },
    best_job_match: null,
    // Add the new hiring-related fields
    accepted_date: null,
    start_date: null,
    contract_length: null,
    placement_fee: null,
    guarantee_end_date: null
  },
  {
    id: "cand-002",
    first_name: "Sam",
    last_name: "Rivera",
    email: "sam.rivera@example.com",
    phone: "+1 (555) 987-6543",
    source: "Referral",
    status: "contacted",
    linkedin_url: "https://linkedin.com/in/sam-rivera",
    experience_years: 3,
    notes: "UX/UI designer with experience in Figma and Adobe XD.",
    created_at: "2023-05-17T14:30:00Z",
    updated_at: "2023-05-17T14:30:00Z",
    last_contact: "2023-05-17T14:30:00Z",
    resume_url: null,
    skills: ["UI Design", "UX Research", "Figma", "Adobe XD", "Prototyping"],
    current_role: "UX Designer at DesignHub",
    assigned_posting: {
      company: "CreativeCo",
      title: "Senior UX Designer"
    },
    best_job_match: null,
    accepted_date: null,
    start_date: null,
    contract_length: null,
    placement_fee: null,
    guarantee_end_date: null
  },
  {
    id: "cand-003",
    first_name: "Maya",
    last_name: "Patel",
    email: "maya.patel@example.com",
    phone: "+1 (555) 456-7890",
    source: "Job Board",
    status: "interview",
    linkedin_url: "https://linkedin.com/in/maya-patel",
    experience_years: 7,
    notes: "Product manager with healthcare tech background.",
    created_at: "2023-05-20T09:15:00Z",
    updated_at: "2023-05-20T09:15:00Z",
    last_contact: "2023-05-20T09:15:00Z",
    resume_url: null,
    skills: ["Product Management", "Agile", "Healthcare", "User Research", "Roadmapping"],
    current_role: "Senior PM at HealthTech",
    assigned_posting: {
      company: "MedTech Solutions",
      title: "Lead Product Manager"
    },
    best_job_match: null,
    accepted_date: null,
    start_date: null,
    contract_length: null,
    placement_fee: null,
    guarantee_end_date: null
  },
  {
    id: "cand-004",
    first_name: "Jordan",
    last_name: "Lee",
    email: "jordan.lee@example.com",
    phone: "+1 (555) 234-5678",
    source: "Conference",
    status: "offer",
    linkedin_url: "https://linkedin.com/in/jordan-lee",
    experience_years: 4,
    notes: "Data scientist with machine learning expertise.",
    created_at: "2023-05-22T11:45:00Z",
    updated_at: "2023-05-22T11:45:00Z",
    last_contact: "2023-05-22T11:45:00Z",
    resume_url: null,
    skills: ["Python", "Machine Learning", "TensorFlow", "Data Analysis", "Statistics"],
    current_role: "Data Scientist at BigData Inc.",
    assigned_posting: {
      company: "AI Innovations",
      title: "Senior Data Scientist"
    },
    best_job_match: null,
    accepted_date: "2023-06-15T00:00:00Z",
    start_date: null,
    contract_length: null,
    placement_fee: null,
    guarantee_end_date: null
  },
  {
    id: "cand-005",
    first_name: "Taylor",
    last_name: "Martinez",
    email: "taylor.martinez@example.com",
    phone: "+1 (555) 345-6789",
    source: "Website",
    status: "hired",
    linkedin_url: "https://linkedin.com/in/taylor-martinez",
    experience_years: 6,
    notes: "DevOps engineer with cloud expertise.",
    created_at: "2023-05-25T13:00:00Z",
    updated_at: "2023-05-25T13:00:00Z",
    last_contact: "2023-05-25T13:00:00Z",
    resume_url: null,
    skills: ["DevOps", "AWS", "Docker", "Kubernetes", "CI/CD"],
    current_role: "DevOps Lead at CloudTech",
    assigned_posting: {
      company: "CloudOps Inc.",
      title: "DevOps Team Lead"
    },
    best_job_match: null,
    accepted_date: "2023-06-01T00:00:00Z",
    start_date: "2023-07-01T00:00:00Z",
    contract_length: "12 months",
    placement_fee: 95000,
    guarantee_end_date: "2023-10-01T00:00:00Z"
  },
  {
    id: "cand-006",
    first_name: "Morgan",
    last_name: "Wong",
    email: "morgan.wong@example.com",
    phone: "+1 (555) 567-8901",
    source: "LinkedIn",
    status: "rejected",
    linkedin_url: "https://linkedin.com/in/morgan-wong",
    experience_years: 2,
    notes: "Marketing specialist with SaaS experience.",
    created_at: "2023-05-28T15:30:00Z",
    updated_at: "2023-05-28T15:30:00Z",
    last_contact: "2023-05-28T15:30:00Z",
    resume_url: null,
    skills: ["Digital Marketing", "SEO", "Content Strategy", "Analytics", "Social Media"],
    current_role: "Marketing Associate at SaaS Co.",
    assigned_posting: {
      company: "SaaS Marketing",
      title: "Marketing Manager"
    },
    best_job_match: null,
    accepted_date: null,
    start_date: null,
    contract_length: null,
    placement_fee: null,
    guarantee_end_date: null
  }
];
